import { useState, useEffect } from "react";
import "@/App.css";
import Login from "./components/Login";
import ScanResultsTable from "./components/ScanResultsTable";
import AdminPanel from "./components/AdminPanel";
import EarningsPrediction from "./components/EarningsPrediction";
import TastytradeControlCenter from "./components/TastytradeControlCenter";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [token, setToken] = useState(null);
  const [username, setUsername] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [currentView, setCurrentView] = useState('dashboard'); // 'dashboard', 'admin', 'tastytrade', or 'earnings'

  useEffect(() => {
    // Check if user is already logged in
    const savedToken = localStorage.getItem('token');
    const savedUsername = localStorage.getItem('username');
    const savedIsAdmin = localStorage.getItem('is_admin') === 'true';
    
    if (savedToken && savedUsername) {
      setToken(savedToken);
      setUsername(savedUsername);
      setIsAdmin(savedIsAdmin);
      setIsAuthenticated(true);
    }
  }, []);

  const handleLoginSuccess = (newToken, newUsername, adminStatus) => {
    setToken(newToken);
    setUsername(newUsername);
    setIsAdmin(adminStatus);
    setIsAuthenticated(true);
    localStorage.setItem('is_admin', adminStatus);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    localStorage.removeItem('is_admin');
    setToken(null);
    setUsername(null);
    setIsAdmin(false);
    setIsAuthenticated(false);
    setCurrentView('dashboard');
  };

  // Function to switch views
  const showDashboard = () => setCurrentView('dashboard');
  const showAdmin = () => setCurrentView('admin');
  const showTastytrade = () => setCurrentView('tastytrade');
  const showEarnings = () => setCurrentView('earnings');

  return (
    <div className="App">
      {isAuthenticated ? (
        currentView === 'admin' && isAdmin ? (
          <AdminPanel
            onLogout={handleLogout}
            onShowScanner={showDashboard}
            onShowEarnings={showEarnings}
            onShowTastytrade={showTastytrade}
            onShowAdmin={showAdmin}
            isAdmin={isAdmin}
          />
        ) : currentView === 'tastytrade' ? (
          <TastytradeControlCenter 
            onLogout={handleLogout}
            onShowScanner={showDashboard}
            onShowEarnings={showEarnings}
            onShowTastytrade={showTastytrade}
            onShowAdmin={showAdmin}
            isAdmin={isAdmin}
          />
        ) : currentView === 'earnings' ? (
          <EarningsPrediction 
            onLogout={handleLogout}
            onShowScanner={showDashboard}
            onShowEarnings={showEarnings}
            onShowTastytrade={showTastytrade}
            onShowAdmin={showAdmin}
            isAdmin={isAdmin}
          />
        ) : (
          <ScanResultsTable 
            onLogout={handleLogout} 
            isAdmin={isAdmin}
            onShowAdmin={showAdmin}
            onShowTastytrade={showTastytrade}
            onShowEarnings={showEarnings}
            onShowScanner={showDashboard}
          />
        )
      ) : (
        <Login onLoginSuccess={handleLoginSuccess} />
      )}
    </div>
  );
}

export default App;
